var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useState, useCallback } from 'react';
import { apiGetOneClientRfp } from '../../../../../actions/ClientRfpActions';
import { apiCreateClientRfpMember, apiDeleteClientRfpMember, apiUpdateClientRfpMemberAdmin, } from '../../../../../actions/ClientRfpMemberActions';
import { RFP_ERROR_CLIENT_MESSAGES } from '../../../../../define/consts/rfp';
import { notify, wrapDispatch, wrapNotifyError, } from '../../../../../helpers/action';
import { useKanaRef } from '../../../../../helpers/use/useKana';
import { getErrorFromErrorObject } from '../../../../../helpers/validate';
/**
 * メンバー追加モーダルのuse
 * @param id
 * @param dispatch
 * @param unmountRef
 * @returns {*}
 */
const useAddMemberModal = (id, dispatch, unmountRef) => {
    const [isShow, changeModal] = useState(false);
    const kanaRef = useKanaRef();
    const showModal = useCallback(() => {
        changeModal(true);
    }, [changeModal]);
    const hideModal = useCallback(() => {
        changeModal(false);
    }, [changeModal]);
    const onSubmit = useCallback((values) => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                yield wrapDispatch(dispatch, apiCreateClientRfpMember(id, Object.assign(Object.assign({}, values), { firstNameKana: kanaRef.current.first.getFurigana(), lastNameKana: kanaRef.current.last.getFurigana() })));
                yield wrapDispatch(dispatch, apiGetOneClientRfp(id));
                if (!unmountRef.current) {
                    hideModal();
                    notify('共有メンバーを追加しました。');
                }
            }
            catch (e) {
                if (unmountRef.current) {
                    return;
                }
                const { code } = getErrorFromErrorObject(e);
                const error = RFP_ERROR_CLIENT_MESSAGES[code];
                /* eslint-disable react/react-in-jsx-scope */
                throw error ? _jsx("span", { children: error }) : new Error(e);
            }
        }));
    }), [id, hideModal, dispatch, unmountRef, kanaRef]);
    return {
        hideModal,
        isShow,
        kanaRef,
        onSubmit,
        showModal,
    };
};
/**
 * 責任者変更モーダルのuse
 * @param id
 * @param dispatch
 * @param unmountRef
 * @returns {*}
 */
const useUpdateAdminModal = (id, dispatch, unmountRef) => {
    const [isShow, changeModal] = useState(false);
    const showModal = useCallback(() => {
        changeModal(true);
    }, [changeModal]);
    const hideModal = useCallback(() => {
        changeModal(false);
    }, [changeModal]);
    const onSubmit = useCallback((values) => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            yield wrapDispatch(dispatch, apiUpdateClientRfpMemberAdmin(id, values));
            yield wrapDispatch(dispatch, apiGetOneClientRfp(id));
            if (!unmountRef.current) {
                hideModal();
                notify('案件責任者を変更しました。');
            }
        }));
    }), [id, hideModal, dispatch, unmountRef]);
    return {
        changeModal,
        hideModal,
        isShow,
        onSubmit,
        showModal,
    };
};
/**
 * メンバー削除モーダルのuse
 * @param id
 * @param members
 * @param dispatch
 * @param unmountRef
 * @returns {*}
 */
const useDeleteMemberModal = (id, members, dispatch, unmountRef) => {
    const [modalState, changeModal] = useState({
        show: false,
        value: undefined,
    });
    const showModal = useCallback((e) => {
        const memberId = parseInt(e.currentTarget.value, 10);
        const value = members.find((v) => v.id === memberId);
        changeModal({ show: true, value });
    }, [changeModal, members]);
    const hideModal = useCallback(() => {
        changeModal((prevState) => (Object.assign(Object.assign({}, prevState), { show: false })));
    }, [changeModal]);
    const memberId = modalState.value && modalState.value.id;
    const onSubmit = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            yield wrapDispatch(dispatch, apiDeleteClientRfpMember(id, memberId));
            yield wrapDispatch(dispatch, apiGetOneClientRfp(id));
            if (!unmountRef.current) {
                changeModal((prevState) => (Object.assign(Object.assign({}, prevState), { show: false })));
                notify('共有メンバーを削除しました。');
            }
        }));
    }), [id, changeModal, dispatch, memberId, unmountRef]);
    return {
        hideModal,
        isShow: modalState.show,
        modalValue: modalState.value,
        onSubmit,
        showModal,
    };
};
export const rfpMemberUseCase = {
    useAddMemberModal,
    useDeleteMemberModal,
    useUpdateAdminModal,
};
export default rfpMemberUseCase;
